module.exports = __webpack_public_path__ + "static/img/pic200-14.bd6ecd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-14.png
// module id = zQM2
// module chunks = 31